export const QUERY_KEY_USER_SNAPS = 'UserSnaps'
export const QUERY_KEY_EXPLORER_SNAPS = 'ExplorerSnaps'
